import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import Employee from 'src/app/model/product/employee';
import IPBoardPlacementType, {
  IPBoardPlacementTypeChoices,
  IPBoardPlacementTypeChoicesArray,
} from 'src/app/model/product/ip-board/ip-board-placement-type';
import {
  SUB_PROJECT_TYPES,
  TypeToDisplayAndClass,
} from 'src/app/model/project/sub-project';
import {
  JobOverviewControllerRequestService,
  JobOverviewYear,
} from 'src/app/services/api/immo/job-overview/job-overview-controller-request.service';
import { RequestService } from 'src/app/services/request.service';
import { SnackService } from 'src/app/services/snack.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';

@Component({
  selector: 'immo-job-year-overview',
  templateUrl: './immo-job-year-overview.component.html',
  styleUrls: ['./immo-job-year-overview.component.scss'],
})
export class ImmoJobYearOverviewComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  data: JobOverviewYear;
  daysNum: number[] = Array.apply(null, Array(31)).map(function (x, i) {
    return i + 1;
  });

  yearOptions: number[] = Array.apply(null, Array(moment().year() - 2018)).map(
    function (x, i) {
      return 2019 + i;
    }
  );
  selectedYear: number = moment().year();

  loadingPlacers: boolean = true;
  placerOptions: Employee[];
  allPlacerOption: Employee = new Employee();
  selectedPlacer: Employee = this.allPlacerOption;

  jobTypeOptions = Array.from(TypeToDisplayAndClass).map((x) => {
    return { value: x[0], display: x[1].display };
  });
  selectedJobType: SUB_PROJECT_TYPES = SUB_PROJECT_TYPES.BASE_PROJECT;

  placementTypeOptions = IPBoardPlacementTypeChoicesArray;
  allPlacementOption: IPBoardPlacementType = new IPBoardPlacementType(
    'Alle',
    null
  );
  selectedPlacementType: IPBoardPlacementType = this.allPlacementOption;

  constructor(
    private requestService: RequestService,
    private snackService: SnackService,
    private jobOverviewService: JobOverviewControllerRequestService
  ) {
    super();
  }

  ngOnInit(): void {
    this.getOverview();
    this.getPlacers();
  }

  async getOverview(): Promise<void> {
    this.data = await this.jobOverviewService.getJobsOverviewYear(
      this.selectedYear,
      this.selectedJobType,
      this.selectedPlacer.id,
      this.selectedPlacementType.ordinal != null
        ? Object.entries(IPBoardPlacementTypeChoices).find(
            (e) => e[1].ordinal === this.selectedPlacementType.ordinal
          )[0]
        : null
    );
  }

  getPlacers(): void {
    this.addSubscription(
      this.requestService.get('/employees/withType/IP_PLACER'),
      (result: any) => {
        this.placerOptions = result.body;
        this.loadingPlacers = false;
      },
      (err) => {
        if (err instanceof Error) {
          this.snackService.showError(err.message);
        } else {
          this.snackService.showError(err);
        }
      }
    );
  }

  compareJobType(o1: any, o2: any): boolean {
    return (
      (o1 == null && o2 == null) ||
      (o1 != null && o2 != null && o1.value === o2)
    );
  }

  compareOrdinalEnum(o1: any, o2: any): boolean {
    return GeneralHelper.compareOrdinalEnum(o1, o2);
  }

  compareEntities(o1: any, o2: any): boolean {
    return GeneralHelper.compareEntities(o1, o2);
  }

  trackById(index: number, obj: any): number {
    return GeneralHelper.trackById(index, obj);
  }
}
